












































































































import { Component, Watch } from 'vue-property-decorator';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';
import { OpportunityDetailsModule } from '@/store/modules/opportunityDetails';
import { CompanyListModule } from '@/store/modules/companyList';

@Component({ name: 'OpportunityCompanyGeneralDetailsEdit' })
export default class extends GiganautVueDialog {
  selectedCompany: any = null;
  entity = {
    prospectCompanyName: '',
    prospectCompanyEmail: '',
    prospectCompanyPhone: '',
    prospectCompanyWebsite: '',
    prospectCompanyTaxNumber: '',
    prospectCompanyRegistrationNumber: '',
  };

  get opportunity() { return OpportunityDetailsModule.opportunity; }
  get saving() { return OpportunityDetailsModule.saving; }
  get companies() { return CompanyListModule.companies; }

  @Watch('dialog')
  async onDialogChanged(val: boolean) {
    if (!val || !this.opportunity) return;
    this.selectedCompany = this.opportunity.company || null;
    this.entity.prospectCompanyName = this.opportunity.prospectCompanyName;
    this.entity.prospectCompanyEmail = this.opportunity.prospectCompanyEmail;
    this.entity.prospectCompanyPhone = this.opportunity.prospectCompanyPhone;
    this.entity.prospectCompanyWebsite = this.opportunity.prospectCompanyWebsite;
    this.entity.prospectCompanyTaxNumber = this.opportunity.prospectCompanyTaxNumber;
    this.entity.prospectCompanyRegistrationNumber = this.opportunity.prospectCompanyRegistrationNumber;
    if (CompanyListModule.companies.length === 0) {
      CompanyListModule.searchCompanies();
    }
  }

  async save() {
    if (!(this.$refs.form as any).validate() || !this.opportunity) return;
    const opp = this.opportunity;
    const newCompanyId = this.selectedCompany ? this.selectedCompany.id : null;

    // Save link change first (when it changed) so the updatedAt timestamp
    // we hand to the prospect-details call reflects the new link state.
    if (newCompanyId !== (opp.companyId || null)) {
      await OpportunityDetailsModule.updateLinks({
        id: opp.id,
        companyId: newCompanyId,
        locationId: opp.locationId,
        contactId: opp.contactId,
        updatedAt: opp.updatedAt,
      });
    }
    // Prospect fields only matter when not linked — a real Company is
    // edited from its own page.
    if (!newCompanyId) {
      const refreshed = OpportunityDetailsModule.opportunity!;
      await OpportunityDetailsModule.updateProspectCompanyDetails({
        id: opp.id,
        updatedAt: refreshed.updatedAt,
        ...this.entity,
      });
    }
    this.dialog = false;
  }
}
